/**
 * Splits an array into contiguous chunks of at most `chunkSize` items.
 *
 * @param items - Source array.
 * @param chunkSize - Maximum length of each chunk (must be positive).
 * @returns Array of chunks (empty when items is empty).
 */
export function chunkArray<T>(items: readonly T[], chunkSize: number): T[][] {
  if (chunkSize <= 0) {
    throw new Error('chunkSize must be positive');
  }
  if (items.length === 0) {
    return [];
  }
  const chunks: T[][] = [];
  for (let i = 0; i < items.length; i += chunkSize) {
    chunks.push(items.slice(i, i + chunkSize));
  }
  return chunks;
}
